import React from 'react';
import ListItem from '../../containers/ListItem';
import { get } from 'lodash';
import { API_HOST } from '../../consts';
import Axios from 'axios';
import moment from 'moment';

class RecursoPrint extends React.Component {
  componentDidMount() {
    this.fetchRecurso();
  }
  constructor(props) {
    super(props);
    this.id = get(this.props, 'match.params.id');
  }
  state = {
    recurso: {}
  };

  fetchRecurso() {
    Axios.get(`${API_HOST}/recursos/recurso/${this.id}`).then((response) => {
      this.setState({ recurso: response.data });
    });
  }
  render() {
    const { recurso } = this.state;

    return (
      <ListItem
        className="bg-cinza"
        key={recurso.id}
        recurso={recurso}
        showContent={true}
        title={`Recurso ${recurso.id}`}
        status={{
          label: get(recurso, 'status.descricao', '-'),
          color: get(recurso, 'status.cor', '#fff')
        }}
        description={[
          { label: 'Elaborador:', value: get(recurso, 'elaborador', '-') },
          {
            label: 'Disciplina:',
            value: get(recurso, 'aplicacao.disciplina.descricao', '-')
          },
          { label: 'Aplicação:', value: get(recurso, 'aplicacao.nome', '-') },
          { label: 'Data do envio:', value: get(recurso, 'data', '-') },
          {
            label: 'Data limite para resposta:',
            value: get(recurso, 'data_limite') ? moment(get(recurso, 'data_limite')).format('DD/MM/YYYY') : '-'
          }
        ]}
      />
    );
  }
}

export default RecursoPrint;
